import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Link } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import Navbar from '../navbar/Navbar'
import Footer from '../footer/footer'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import './VideoClass.css'


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

export default function FullWidthGrid() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Navbar />
            <Link id='back' to="/">
                <Button style={{ margin: '10px', marginTop: '80px' }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
            <Grid id='topgrid' container spacing={2} justify='center' style={{ padding: '10px' }}>
                <Grid item xs={12}>
                    <Paper style={{ backgroundColor: '#26A65B', color: 'white' }} className={classes.paper}>Select your C.S.E semester</Paper>
                </Grid>

                <Grid item xs={6} sm={3} md={4}>
                    {/* <Link to='/ThirdSemVideoClass' id='lnk'> */}
                    <Link to='/Notfound' id='lnk'>
                        <Paper id='Videonotes' className={classes.paper}>
                            3rd sem
                            <Divider style={{ backgroundColor: 'white' }} />
                            {/* <p id='Ttag'>Mathematics 3</p>
                            <p id='Ttag'>ADE</p>
                            <p id='Ttag'>DSC</p>
                            <p id='Ttag'>Computer Organisation</p>
                            <p id='Ttag'>Unix System Programming</p>
                            <p id='Ttag'>DMS</p> */}
                            <p id='Ttag'>Not Available</p>

                        </Paper>
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3} md={4}>
                    {/* <Link to='/4th' id='lnk'> */}
                    <Link to='/Notfound' id='lnk'>
                        <Paper id='Videonotes' className={classes.paper}>
                            4th sem
                            <Divider style={{ backgroundColor: 'white' }} />
                            {/* <p id='Ttag'>Mathematics 4</p>
                            <p id='Ttag'>Software Engineering</p>
                            <p id='Ttag'>DAA</p>
                            <p id='Ttag'>Micro Processor</p>
                            <p id='Ttag'>OOPS</p>
                            <p id='Ttag'>Data Communication</p> */}
                            <p id='Ttag'>Not Available</p>

                        </Paper>
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3} md={4}>
                    {/* <Link to='/5th' id='lnk'> */}
                    <Link to='/Notfound' id='lnk'>
                        <Paper id='Videonotes' className={classes.paper}>
                            5th sem
                            <Divider style={{ backgroundColor: 'white' }} />
                            {/* <p id='Ttag'>M.E</p> 
                            <p id='Ttag'>C.N</p> 
                            <p id='Ttag'>DBMS</p> 
                            <p id='Ttag'>ATC</p>
                            <p id='Ttag'>ADV JAVA & JEE</p> 
                            <p id='Ttag'>Artificail Intelligence (A.I)</p>
                            <p id='Ttag'>.NET</p> */}
                            <p id='Ttag'>Not Available</p>

                        </Paper>
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3} md={4}>
                    <Link to='/SixthSemVideo' id='lnk'>
                        <Paper id='Videonotes' className={classes.paper}>
                            6th sem
                            <Divider style={{ backgroundColor: 'white' }} />
                            {/* <p id='Ttag'>CNS</p> 
                            <p id='Ttag'>CG</p> 
                            <p id='Ttag'>OS</p> 
                            <p id='Ttag'>OR</p>
                            <p id='Ttag'>Python</p> 
                            <p id='Ttag'>SS & CD</p> */}
                            <p id='Ttag'>Available</p>
                        </Paper>
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3} md={4}>
                    {/* <Link to='/7th' id='lnk'> */}
                    <Link to='/Notfound' id='lnk'>
                        <Paper id='Videonotes' className={classes.paper}>
                            7th sem
                            <Divider style={{ backgroundColor: 'white', color: 'white' }} />
                            {/* <p id='Ttag'>Storage area network (SAN)</p> 
                            <p id='Ttag'>ACA</p> 
                            <p id='Ttag'> WEB</p> 
                            <p id='Ttag'>Machine Learning</p>
                            <p id='Ttag'>Unix system programming</p> 
                            <p id='Ttag'>INS</p> */}
                            <p id='Ttag'>Not Available</p>

                        </Paper>
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3} md={4}>
                    {/* <Link to='/8th' id='lnk'> */}
                    <Link to='/Notfound' id='lnk'>
                        <Paper id='Videonotes' className={classes.paper}>
                            8th sem
                            <Divider style={{ backgroundColor: 'white', color: 'white' }} />
                            <p id='Ttag'>Not Available</p>


                        </Paper>
                    </Link>
                </Grid>
            </Grid>

            <Footer />
        </div>
    );
}
